// Layouts

import LayoutField from "../../Field/LayoutField";
import LayoutFieldset from "../../Fieldset/LayoutFieldset";

import LayoutGrid from "../../Layout/LayoutGrid";

import LayoutDocument from "../../Document/LayoutDocument";
import LayoutFinder from "../../Finder/LayoutFinder";
import LayoutSection from "../../Section/LayoutSection";

import LayoutBlock from "../../Block/LayoutBlock";
import LayoutModule from "../../Module/LayoutModule";

import LayoutMedia from "../../Media/LayoutMedia";

import LayoutGeocoder from '../../Geocoder/LayoutGeocoder';
import LayoutGeocoderMap from '../../Geocoder/LayoutGeocoderMap';
import LayoutGeocoderSearch from '../../Geocoder/LayoutGeocoderSearch';

var layouts = {
    "field": LayoutField,
    "fieldset": LayoutFieldset,

    "grid": LayoutGrid,

    "document": LayoutDocument,
    "finder": LayoutFinder,

    "section": LayoutSection,
    "block": LayoutBlock,
    "module": LayoutModule,

    "media": LayoutMedia,

    "geocoder": LayoutGeocoder,
    "geocoder-map": LayoutGeocoderMap,
    "geocoder-search": LayoutGeocoderSearch

};

export default layouts;